export const EDITOR_MODE_RICH = 1;
export const EDITOR_MODE_HTML = 2;
export const EDITOR_MODE_MARKDOWN = 3;

export const EDITOR_MODES = [
  { text: '기본모드', value: EDITOR_MODE_RICH },
  { text: '마크다운', value: EDITOR_MODE_MARKDOWN },
  { text: 'HTML', value: EDITOR_MODE_HTML },
];
